import { render, staticRenderFns } from "./templateSelect.vue?vue&type=template&id=2f627c12&"
import script from "./templateSelect.vue?vue&type=script&lang=js&"
export * from "./templateSelect.vue?vue&type=script&lang=js&"
import style0 from "./templateSelect.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports